import '../styles/pilot.css';
import '../pilot-assignment/pilotassignment.css';


import { useEffect, useState } from 'react';
import {
    PilotageViewTypes
} from '../../../services/SystemNames';
import { useNavigate, useParams } from 'react-router';
import { PilotagesAssigned } from './components/PilotagesAssigned';
import { PilotagesExecuted } from './components/PilotagesExecuted';
import { AppContainerContent } from '../../../components/layout/app/AppContainerContent';
import ContentGrid from '../../../components/layout/ContentGrid';
import { BottomMenu } from '../../../components/layout/menus/bottom/BottomMenu';
import { useHeader } from '../../../components/hooks/useHeader';
import Spacer from 'components/layout/Spacer';

export default function Index() {

    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useHeader("Mine oppdrag");

    const {
        view = PilotageViewTypes.Assigned
    } = useParams();

    // Initialize function
    useEffect(() => {
        window.addEventListener('online', handleOnOffline);
        window.addEventListener('offline', handleOnOffline);

        return () => {
            window.removeEventListener('online', handleOnOffline);
            window.removeEventListener('offline', handleOnOffline);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppContainerContent
            bottomMenu={<PilotagesBottomMenu />}>
            {(() => {
                switch (view) {
                    case PilotageViewTypes.Assigned:
                        return (
                            <PilotagesAssigned />
                        )
                    case PilotageViewTypes.Executed:

                        return (
                            isOnline ?
                                <PilotagesExecuted/>
                                :
                                <ContentGrid title="Utførte losoppdrag" titleIcon="check">
                                    <Spacer height={40} />
                                            <h3>
                                                Man må være på nett for å se utførte oppdrag.
                                            </h3>
                                </ContentGrid>
                        );
                    default:
                        return null;
                }
            })()}
        </AppContainerContent>
    );

    function handleOnOffline() {
        setIsOnline(navigator.onLine);
    }
}

const PilotagesBottomMenu = () => {

    const {
        view = PilotageViewTypes.Assigned
    } = useParams();

    const navigate = useNavigate();

    return (
        <BottomMenu
            onCallback={onBottomMenuSelect}
            selectedEvent={view}
            items={[
                {
                    title: "Aktuelle",
                    icon: "anchor",
                    event: PilotageViewTypes.Assigned,
                },
                {
                    title: "Utførte",
                    icon: "check",
                    event: PilotageViewTypes.Executed,
                },
            ]}
        />
    )

    function onBottomMenuSelect(item) {
        if (view === item.event) return;
        navigate(`/pilot/pilotages/${item.event}`, { replace: true });
    }
}
